import React from "react";
import { useTranslation } from "react-i18next";
import { CButton } from "@app/components/Common";
import { View } from "@/styles/reactnative";

interface IProps {
  closeModal?: () => void;
  action?: () => void;
}

const OrderModalFooter = ({ closeModal, action }: IProps) => {
  const { t } = useTranslation();

  return (
    <View
      style={{
        flexDirection: "row",
        justifyContent: "center",
        gap: 12,
        width: "100%",
        marginTop: 18,
        position: "relative",
      }}
    >
      <CButton
        title={t("cancel")}
        style={{
          flex: 1,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          background: 'transparent',
          color: '#ffffff',
          borderRadius: 6,
          border: '1px solid #353535',
          cursor: "pointer",
          fontSize: 14,
          fontWeight: 700,
          height: 42,
          letterSpacing: '-0.28px',
          fontFamily: 'NanumSquareRound'
        }}
        onClick={() => {
          closeModal && closeModal();
        }}
      />
      <CButton
        title={t("confirm")}
        style={{
          flex: 1,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          background: '#07D993',
          color: '#0d1117',
          borderRadius: 6,
          cursor: "pointer",
          fontSize: 14,
          fontWeight: 700,
          height: 42,
          letterSpacing: '-0.28px',
          fontFamily: 'NanumSquareRound'
        }}
        onClick={() => {
          action && action();
          closeModal && closeModal();
        }}
      />
    </View>
  );
};

export default OrderModalFooter;
